import React from 'react';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import {labels} from '../../../../../../../util/utils';
import EllipsesControl from '../../../../../../Common/EllipsesControl/EllipsesControl';
import AccountExecutionType from '../../../../../Accounts/AccountExecutionType/AccountExecutionType';

export default function NameAccountCellRenderer(params) {
	const {value, data} = params;

	return (
		<StyledNameAccountCellRenderer className="StyledNameAccountCellRenderer">
			<span className="AccountNameLabelTxt">
				<EllipsesControl content={value} tooltip={value} noOfLines={1} />
			</span>
			<AccountExecutionType executionTypeId={data?.executionTypeId} />
			{data?.hasEstimate && (
				<SVGICONS
					alt={labels.estimate}
					hoverText={labels.estimate}
					name={'accountingCalculator'}
					styleName="AccountIcon medium"
					c
				/>
			)}
		</StyledNameAccountCellRenderer>
	);
}
const StyledNameAccountCellRenderer = styled.section`
	display: flex;
	align-items: center;
	width: 100%;
	.AccountNameLabelTxt {
		width: auto;
		justify-content: flex-start;
	}
	.AccountIcon {
		margin-left: auto;
		width: var(--px-18) !important;
		height: var(--px-18) !important;
		justify-content: flex-end;
		fill: var(--neutrals-900);
	}
`;
